/**
 * Settings sidebar navigation (admin).
 * Dark green vertical nav: メールテンプレート作成, 申請管理, メールアドレス設定, 郵便番号データ.
 * Used inside SettingsHome; active item has a lighter green background.
 */
import React from 'react';
import { useSecretExpiry } from '../../../contexts/SecretExpiryContext';
import './navBarSettings.css';

export type SettingsNavItem =
  | 'email-template'
  | 'application'
  | 'email-address'
  | 'postal-code-data'
  | 'activity-log';

export interface NavbarSettingsProps {
  /** Currently active item */
  activeItem?: SettingsNavItem;
  /** Callback when an item is clicked */
  onItemChange?: (item: SettingsNavItem) => void;
}

const SETTINGS_ITEMS: { id: SettingsNavItem; label: string }[] = [
  { id: 'email-template', label: 'メールテンプレート作成' },
  { id: 'application', label: '申請管理' },
  { id: 'email-address', label: 'メールアドレス設定' },
  { id: 'postal-code-data', label: '郵便番号データアップロード' },
  { id: 'activity-log', label: '操作ログ' },
];

const NavbarSettings: React.FC<NavbarSettingsProps> = ({
  activeItem = 'email-template',
  onItemChange,
}) => {
  const secretExpiry = useSecretExpiry();

  return (
    <nav className="settings-nav" aria-label="管理者設定">
      <ul className="settings-nav__list">
        {SETTINGS_ITEMS.map((item) => (
          <li key={item.id} className="settings-nav__item">
            <button
              type="button"
              className={`settings-nav__btn ${
                activeItem === item.id ? 'settings-nav__btn--active' : ''
              } ${item.id === 'email-address' && secretExpiry.warning ? `settings-nav__btn--dot settings-nav__btn--dot-${secretExpiry.severity}` : ''}`}
              onClick={() => onItemChange?.(item.id)}
              aria-current={activeItem === item.id ? 'page' : undefined}
            >
              {item.label}
              {item.id === 'email-address' && secretExpiry.warning && (
                <span className="settings-nav__dot" aria-hidden />
              )}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default NavbarSettings;
